import { FormInstance, Row } from "antd";
import { SearchEmail } from "./SeacrhEmail";
import { SearchMessage } from "./SearchMessage";
import { UsersList } from "./UsersList";
import { ValidationErrors } from "./ValidationErrors";

type SelectFormExistingFormProps = {
  form: FormInstance;
  customerId: string | null | undefined;
  errors: any;
  activeTab: string;
  showMessage: boolean;
  searchData: any[];
  search: string;
  debouncedSearch: string;
  isLoading: boolean;
  setSelectedUser: React.Dispatch<React.SetStateAction<any>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  onSearchChange: (e: any) => void;
  onClearSearch: () => void;
  onDataFetched: (value: any[], show: boolean) => void;
  onChangeTab: (key: string) => void;
};

export const SelectFormExistingForm = ({
  form,
  customerId,
  errors,
  activeTab,
  showMessage,
  searchData,
  search,
  debouncedSearch,
  isLoading,
  setIsLoading,
  onSearchChange,
  onClearSearch,
  onDataFetched,
  onChangeTab,
  setSelectedUser,
}: SelectFormExistingFormProps) => {
  return (
    <Row className="pt-8 d-block h-100 select-existing">
      <Row className="d-block px-6">
        {errors && <ValidationErrors data={errors} />}
        <p className="my-0 pb-4 text-md w-500">Email for login</p>
        <Row>
          <Row className="d-block position-relative w-100 search-email">
            <SearchEmail
              form={form}
              tabNumber="2"
              customerId={customerId}
              onDataFetched={onDataFetched}
              hideLabel
              search={search}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              debouncedSearch={debouncedSearch}
              onSearchChange={onSearchChange}
              onClearSearch={onClearSearch}
              activeTab={activeTab}
              showMessage={showMessage}
            />
            {showMessage && (
              <SearchMessage activeTab={activeTab} onChangeTab={onChangeTab} />
            )}
          </Row>
        </Row>
      </Row>
      <Row className="d-block user-search-list__container overflow-y-auto px-6">
        <UsersList
          form={form}
          isLoading={isLoading}
          searchData={searchData}
          setSelectedUser={setSelectedUser}
        />
      </Row>
    </Row>
  );
};
